import { api } from '../api';
import type { Supplier, CreateSupplierInput, UpdateSupplierInput } from '@/types/supplier';
import type { PaginationParams, PaginatedResponse } from '@/types/common';

function buildQueryString(params?: PaginationParams): string {
  if (!params) return '';
  const sp = new URLSearchParams();
  if (params.page) sp.set('page', params.page.toString());
  if (params.limit) sp.set('limit', params.limit.toString());
  if (params.sortBy) sp.set('sortBy', params.sortBy);
  if (params.sortOrder) sp.set('sortOrder', params.sortOrder);
  if (params.search) sp.set('search', params.search);
  const qs = sp.toString();
  return qs ? `?${qs}` : '';
}

export const supplierApi = {
  getAll: (params?: PaginationParams) =>
    api.get<PaginatedResponse<Supplier>>(`/suppliers${buildQueryString(params)}`),
  getById: (id: string | number) => api.get<Supplier>(`/suppliers/${id}`),
  create: (data: CreateSupplierInput) => api.post<Supplier>('/suppliers', data),
  update: (id: string | number, data: UpdateSupplierInput) => api.patch<Supplier>(`/suppliers/${id}`, data),
  delete: (id: string | number) => api.delete(`/suppliers/${id}`),
};
